import Logo from "../../image/whiteLogo.png";
import "./navbar.css";
import data from "./data";

const Navbar = () => {
  return (
    <nav>
      <div className="container  nav__container">
        <a href="index.html" className="nav__logo">
          <img width={100} src={Logo} alt="Logo" />
        </a>
        <ul className="nav__menu">
          {data.map((item) => (
            <li key={item.id}>
              <a href={item.link}>{item.title}</a>
            </li>
          ))}
        </ul>
        <button></button>
      </div>
    </nav>
  );
};

export default Navbar;
